'use client'

import { useEffect } from "react"
import { XMarkIcon } from "@heroicons/react/20/solid"
import classNames from "classnames"

export default function Popup(props) {

    const { className, contentClassName, children, onClose } = props

    useEffect(() => {
        document.body.style.overflow = 'hidden'

        return () => {
            document.body.style.overflow = 'auto'
        }
    }, [])

    return (
        <div
            className={classNames('popup', className)}
            onClick={(e) => {
                if (e.target === e.currentTarget && onClose) {
                    onClose()
                }
            }}
        >
            <div className={classNames('popup-content', contentClassName)}>
                { onClose &&
                    <button className="btn btn-close" onClick={onClose}>
                        <XMarkIcon />
                    </button>
                }
                {children}
            </div>
        </div>
    )
}